export default __webpack_public_path__ + "static/media/chanon-wide.89af424f.png";